import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #888;
`;

export const TabsContainer = styled.div`
    border-bottom: 1px solid #74ace3;
`;

interface IStaticFieldProps {
    width?: string;
}

export const StaticField = styled.div<IStaticFieldProps>`
    display: flex;
    flex-direction: column;
    width: ${props => props.width || 'auto'};
    min-width: ${props => props.width || 'auto'};
    max-width: ${props => props.width || 'auto'};
`;

export const Title = styled.div`
    font-size: 0.7em;
    color: gray;
`;

interface IValueProps {
    bold?: boolean;
}

export const Value = styled.div<IValueProps>`
    font-size: 1em;
    color: black;
    font-weight: ${props => props.bold ? 'bold' : 'normal' };
`;

export const Options = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
    width: 100%;
`;